import { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Spinner } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { getMyFastrackNodes } from '../../api/fastrackApi';
import { getPlansWithStatus } from '../../api/planApi';
import { ActiveNodeCard } from '../../components/fastrack/ActiveNodeCard';

const cyan = '#00e5ff';
const accent = '#cc66ff';
const cardDark = { background: 'linear-gradient(135deg, #0d0d0d 0%, #1a0033 100%)', color: '#fff', border: '1px solid #9933ff44' };

const placeholderStyle = { ...cardDark, minHeight: 200 };

const FastrackStatus = () => {
  const navigate = useNavigate();
  const [plans, setPlans] = useState([]);
  const [fastrackByPlan, setFastrackByPlan] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([getPlansWithStatus(), getMyFastrackNodes()])
      .then(([plansRes, fastrackRes]) => {
        setPlans(plansRes.data.plans || []);
        const map = {};
        (fastrackRes.data.plans || []).forEach((pd) => { map[pd.plan._id] = pd; });
        setFastrackByPlan(map);
      })
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <Container className="mt-5 text-center">
        <Spinner animation="border" style={{ color: accent }} />
      </Container>
    );
  }

  return (
    <div style={{ minHeight: '100vh', background: '#0a0a0a', paddingBottom: 40 }}>
      <Container className="pt-4">
        <button
          onClick={() => navigate('/account-status')}
          style={{ background: 'none', border: 'none', color: cyan, fontSize: 13, cursor: 'pointer', marginBottom: 20, padding: 0 }}
        >
          ‹ Back to Account Status
        </button>

        <div className="mb-4">
          <h4 style={{ color: '#fff', fontWeight: 700 }}>Fastrack Status</h4>
          <div style={{ color: '#aaa', fontSize: 13 }}>Current binary node for every slot</div>
        </div>

        <Row className="g-3">
          {plans.filter((plan) => plan.purchased).map((plan) => {
            const fastrackData = fastrackByPlan[plan._id];
            const activeNode = fastrackData?.nodes?.find((n) => n.status === 'active');
            const cyclesCompleted = fastrackData?.completedCycles ?? 0;
            const totalEarned = (fastrackData?.nodes || [])
              .filter((n) => n.bonusStatus === 'credited')
              .reduce((sum, n) => sum + (n.bonusAmount || 0), 0);

            const statsRow = (
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 12 }}>
                <div style={{ textAlign: 'left' }}>
                  <div style={{ color: '#888', fontSize: 10, textTransform: 'uppercase', letterSpacing: '0.05em' }}>Cycles Completed</div>
                  <div style={{ color: accent, fontWeight: 700, fontSize: 14 }}>{cyclesCompleted}</div>
                </div>
                <div style={{ textAlign: 'right' }}>
                  <div style={{ color: '#888', fontSize: 10, textTransform: 'uppercase', letterSpacing: '0.05em' }}>Total Earned</div>
                  <div style={{ color: '#66ff99', fontWeight: 700, fontSize: 14 }}>{totalEarned.toFixed(2)} USDT</div>
                </div>
              </div>
            );

            return (
              <Col xs={12} md={4} key={plan._id}>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8 }}>
                  <span style={{ color: '#fff', fontWeight: 700, fontSize: 14 }}>{plan.planName}</span>
                  <span style={{ color: '#66ff99', fontSize: 12, fontWeight: 600 }}>{plan.amount} USDT</span>
                </div>

                {activeNode ? (
                  <ActiveNodeCard node={{ ...activeNode, planId: plan }} hideHeader hideFooter topStats={statsRow} />
                ) : (
                  <Card style={placeholderStyle} className="p-3">
                    {statsRow}
                    <div className="d-flex align-items-center justify-content-center text-center" style={{ minHeight: 140 }}>
                      <div style={{ color: '#555', fontSize: 12 }}>No active node right now</div>
                    </div>
                  </Card>
                )}
              </Col>
            );
          })}
        </Row>
      </Container>
    </div>
  );
};

export default FastrackStatus;
